<template>
  <FormSect class="FormLaptopBuckets" :title="$t('label')">
    <div class="buckets">
      <Field
        v-for="(bucketsPrice, index) in bucketsPrices"
        :key="index"
        type="money"
        :value="bucketsPrice"
        @update:value="setBucketPrice($event, index)">
        <Icon class="remove" name="cross" @click="remove(index)" />
      </Field>
      <Btn class="ib" @click="add">
        {{ $t('add') }}
      </Btn>
      <Btn v-if="isOutdated" class="ib" @click="$emit('refresh')">
        {{ $t('refresh') }}
      </Btn>
    </div>
  </FormSect>
</template>

<script>
import { removeIndex } from '@utils/collections'
import { update } from 'rambda'

export default {
  props: {
    bucketsPrices: Array,
  },
  data() {
    return {
      bucketsSynced: [],
    }
  },
  computed: {
    isOutdated() {
      return this.bucketsPrices.toString() !== this.bucketsSynced.toString()
    },
  },
  methods: {
    add() {
      const priceLast = this.bucketsPrices[this.bucketsPrices.length - 1]

      this.setPrices([
        ...this.bucketsPrices,
        priceLast + 100,
      ])
    },
    remove(index) {
      this.setPrices(removeIndex(index, this.bucketsPrices))
    },
    setPrices(value) {
      this.$emit('update:bucketsPrices', value)
    },
    setBucketPrice(price, index) {
      this.setPrices(update(
        index,
        price,
        this.bucketsPrices,
      ))
    },
  },
  watch: {
    bucketsPrices: {
      immediate: true,
      handler(bucketsPrices) {
        this.bucketsSynced = [...bucketsPrices]
      },
    },
  },
}
</script>

<style lang="scss">
.FormLaptopBuckets {
  .buckets {
    display: flex;
  }

  .Btn {
    height: fit-content;
    margin-right: 1rem;
    white-space: nowrap;

    &:last-of-type {
      margin-right: 0;
    }
  }

  .Field-cont {
    margin-right: 1rem;
    position: relative;

    .remove {
      color: $danger;
      cursor: pointer;
      font-size: $h6;
      height: 100%;
      left: auto;
      position: absolute;
      right: 0;
      top: 0;
      width: 2.5rem;
    }

    input {
      text-align: center;
    }
  }

}
</style>

<i18n>
{
  "en": {
    "add": "Add",
    "label": "Price buckets",
    "refresh": "Update list"
  }
}
</i18n>
